import type { UpdateMasterDataParams } from 'master-data/contexts/LayoutMasterDataProvider/LayoutMasterDataProvider'

export const FILTERED_KEYWORD = ':filtered'

const updateItemListName = (
	itemListName: string,
	shouldHaveFilteredKw: boolean
) => {
	let result = itemListName
	if (shouldHaveFilteredKw && !itemListName.endsWith(FILTERED_KEYWORD)) {
		result = `${itemListName}${FILTERED_KEYWORD}`
	}
	if (!shouldHaveFilteredKw && itemListName.endsWith(FILTERED_KEYWORD)) {
		result = itemListName.slice(0, -FILTERED_KEYWORD.length)
	}
	return result
}

export const updateMasterDataItemListName = (
	itemListName: string,
	url: string,
	hasFiltersApplied: boolean
): UpdateMasterDataParams => ({
	url,
	custom: {
		item_list_name: updateItemListName(itemListName, hasFiltersApplied),
	},
})
